<template>
  <v-layout style="overflow: hidden">
    <v-flex
      xs6
      ml-4
      mt-3
      style="display: flex; flex-direction: column; justify-content: center;"
    >
      <v-layout column>
        <v-flex class="property"
          >クリエイティブID： {{ creative.anCreativeId }}</v-flex
        >
        <v-flex class="property">クリエイティブ名： {{ creative.name }}</v-flex>
        <v-flex class="property">
          遷移先URL：
          <a
            :href="creative.landingPageUrl"
            class="url"
            target="_blank"
            rel="noopener"
          >
            {{ creative.landingPageUrl }}
            <v-icon small>launch</v-icon>
          </a>
        </v-flex>
        <v-flex v-if="!hideStatus" class="property">
          ステータス：
          <AppStatus :value="creative.status" />
          <span v-if="creative.isExpired">
            （期限切れ）
          </span>
        </v-flex>
        <v-flex class="property">
          審査ステータス：
          <CreativeAnAuditStatus
            :anAuditStatus="creative.anAuditStatus"
            :status="creative.status"
          />
          <CreativeAuditFeedback
            v-if="!hideFeedbacks"
            :value="creative.anAuditFeedback"
            class="feedback mb-2"
          />
        </v-flex>
        <v-flex class="property">
          <div :style="{ position: 'relative' }">
            <v-menu open-on-hover bottom offset-y>
              <template v-slot:activator="{ on }">
                <a v-on="on" class="auditIcon">
                  <CreativeAuditIcon :creative="creative" />
                </a>
              </template>
              <v-card class="popover">
                <v-card-text>
                  Google 経由での配信は、プラットフォーム審査が承認済みかつ
                  Google 審査ステータスが承認済みの場合のみ配信されます。
                </v-card-text>
              </v-card>
            </v-menu>
            Google審査ステータス：
            <CreativeAnGoogleStatus :value="creative.anGoogleStatus" />
            <CreativeAuditFeedback
              v-if="!hideFeedbacks"
              :value="creative.anGoogleFeedback"
              class="feedback mb-2"
            />
          </div>
        </v-flex>
        <v-flex v-if="creative.smartNewsAuditStatus" class="property">
          SmartNews審査ステータス：
          <CreativeSmartNewsAuditStatus
            :smartNewsAuditStatus="creative.smartNewsAuditStatus"
            :status="creative.status"
          />
        </v-flex>
        <v-flex>
          <hr noshade />
        </v-flex>
        <v-flex class="property">見出し： {{ creative.title }}</v-flex>
        <v-flex class="property" style="overflow-wrap: break-word;"
          >説明文： {{ creative.description }}</v-flex
        >
        <v-flex v-if="iconImage !== null" class="property">
          <v-layout>
            <v-flex xs3>
              <div>小画像</div>
              <div @contextmenu.prevent>
                <img
                  :src="iconImage.cdnUrl"
                  style="width: 100%; max-width: 100px;"
                  alt="description"
                />
              </div>
            </v-flex>
            <v-flex
              xs6
              style="padding: 0px 1.5rem; display: flex; flex-direction: column; justify-content: center;"
            >
              <div>ファイル名： {{ iconImage.name }}</div>
              <div>
                画像サイズ： {{ iconImage.width }} x {{ iconImage.height }} px
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="mainImage !== null" class="property">
          <v-layout>
            <v-flex xs3>
              <div>大画像</div>
              <div @contextmenu.prevent>
                <img
                  :src="mainImage.cdnUrl"
                  style="width: 100%; max-width: 100px;"
                  alt="description"
                />
              </div>
            </v-flex>
            <v-flex
              xs6
              style="padding: 0px 1.5rem; display: flex; flex-direction: column; justify-content: center;"
            >
              <div>ファイル名： {{ mainImage.name }}</div>
              <div>
                画像サイズ： {{ mainImage.width }} x {{ mainImage.height }} px
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex style="font-size: 12px; margin-bottom: 0.5rem;"
          >※
          AIクリエイティブ工房で生成した画像のダウンロードは禁止されています。</v-flex
        >
        <v-flex class="property"
          >広告主体者名： {{ creative.sponsoredBy }}</v-flex
        >
        <v-flex class="property">CTA： {{ creative.callToAction }}</v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs1>
      <v-spacer />
    </v-flex>
    <v-flex xs5 mt-3>
      <InfeedPreview
        :title="creative.title"
        :description="creative.description"
        :mainImageUrl="mainImage === null ? '' : mainImage.cdnUrl"
        :iconImageUrl="iconImage === null ? '' : iconImage.cdnUrl"
        :sponsoredBy="creative.sponsoredBy"
        :cta="creative.callToAction"
        :lpUrl="creative.landingPageUrl"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import CreativeAuditFeedback from './CreativeAuditFeedback'
import CreativeAuditIcon from './CreativeAuditIcon'
import CreativeAnGoogleStatus from './CreativeAnGoogleStatus'
import CreativeAnAuditStatus from './CreativeAnAuditStatus'
import CreativeSmartNewsAuditStatus from './CreativeSmartNewsAuditStatus'
import InfeedPreview from './CreativeInfeedPreview'

export default {
  name: 'InfeedDetail',
  components: {
    CreativeAnAuditStatus,
    CreativeAnGoogleStatus,
    CreativeSmartNewsAuditStatus,
    CreativeAuditIcon,
    CreativeAuditFeedback,
    InfeedPreview,
  },
  props: {
    creative: {
      type: Object,
      required: true,
    },
    mainImage: {
      type: Object,
      required: true,
    },
    iconImage: {
      type: Object,
      required: true,
    },
    hideFeedbacks: Boolean,
    hideStatus: Boolean,
  },
}
</script>

<style scoped>
.auditIcon {
  display: inline-block;
  position: absolute;
  width: 30px;
  left: -30px;
}

.popover {
  max-width: 300px;
}

.feedback {
  max-width: 450px;
  margin-left: 12px;
}

.property {
  margin-bottom: 0.5rem;
}

.url {
  word-wrap: break-word;
}

hr {
  border-color: #dededf;
  margin-top: 8px;
  margin-bottom: 18px;
}

img {
  user-select: none;
  pointer-events: none;
}
</style>
